import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';

const slides = episodes.slice(0, 4);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [paused]);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + slides.length) % slides.length);
  };

  const active = slides[index];

  return (
    <section
      className="relative w-full h-[520px] md:h-[680px] overflow-hidden film-grain"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === index ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={slide.cover}
            alt={`${slide.title} 主视觉`}
            title={`${slide.title} 无颜之月动漫`}
            className="w-full h-full object-top object-cover scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/70 to-background-950/30"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/40 to-transparent"></div>
        </div>
      ))}

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-center">
        <div className="w-full max-w-2xl">
          <div key={active.id} className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 border border-accent-500/40 px-3 py-1 text-xs font-medium text-accent-300">
              <i className="ri-fire-line"></i>
              第一季 · 全集在线
            </span>
            <h1 className="mt-5 font-heading font-bold text-3xl md:text-5xl leading-tight text-foreground-50 text-balance">
              无颜之月动漫第一季全集
            </h1>
            <p className="mt-3 font-heading text-lg md:text-xl text-accent-400">{active.title}</p>
            <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl line-clamp-3">
              {active.summary}
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link
                to={`/detail/${active.id}`}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看本集
              </Link>
              <Link
                to="/category"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-background-800/70 border border-primary-500/40 px-6 py-3 text-sm font-medium text-foreground-100 hover:bg-background-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-list-check"></i>
                浏览全部剧集
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute z-20 bottom-6 left-4 md:left-8 flex items-center gap-3">
        <button
          type="button"
          onClick={() => go(-1)}
          aria-label="上一张"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-900/70 border border-primary-500/30 text-foreground-100 hover:bg-primary-500/30 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          aria-label="下一张"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-900/70 border border-primary-500/30 text-foreground-100 hover:bg-primary-500/30 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
        <div className="ml-2 flex items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                i === index ? 'w-8 bg-accent-500' : 'w-3 bg-foreground-600/60 hover:bg-foreground-400'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}